import { render, staticRenderFns } from "./WorkBenchTab.vue?vue&type=template&id=4558e82f&scoped=true"
import script from "./WorkBenchTab.vue?vue&type=script&lang=js"
export * from "./WorkBenchTab.vue?vue&type=script&lang=js"
import style0 from "./WorkBenchTab.vue?vue&type=style&index=0&id=4558e82f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4558e82f",
  null
  
)

export default component.exports